import React from "react";
import { useHistory } from "react-router";
import FeatureExplanation from "../../components/FeatureExplanation";

interface Props {
  title: string;
  paragraphs: any[];
  buttonText?: string;
  buttonLink?: string;
}

const LockedWorkspace: React.FC<Props> = ({
  title,
  paragraphs,
  buttonText,
  buttonLink
}) => {
  const history = useHistory();

  return (
    <FeatureExplanation title={title} paragraphs={paragraphs}>
      {buttonText && buttonLink && (
        <button
          type="button"
          className="mt-6 inline-flex items-center justify-center px-3 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-hotspotty-400 hover:bg-hotspotty-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-hotspotty-400"
          onClick={() => history.push(buttonLink)}
        >
          {buttonText}
        </button>
      )}
    </FeatureExplanation>
  );
};

export default LockedWorkspace;
